enum AdditionOwnershipType {
    Heir = 1,
    Remainderman,
    NonExecutive,
    NonParticipating,
    TransferOnDeath,
    NakedOwner,
}

export default AdditionOwnershipType;



// WEBPACK FOOTER //
// ./src/models/tract_detail/AdditionalOwnershipType.ts